import { Tooltip } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import { useLayoutEffect, useRef, useState } from "react";

export const OverflowCell = ({ value, tooltipId, children }) => {
    const textRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);

    useLayoutEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const isOverflow = el.scrollWidth > el.clientWidth;

        setShowTooltip(prev => (prev !== isOverflow ? isOverflow : prev));
    }, [value]);

    return (
        <>
            <div ref={textRef} id={tooltipId} className="cell-text">
                {children}
            </div>

            {showTooltip && (
                <Tooltip label={value} targetId={tooltipId} />
            )}
        </>
    );
};
OverflowCell.propTypes = {
    value: PropTypes.any,
    className: PropTypes.string
};